// Footer Mobile accordion - start
var mq_footer_max = window.matchMedia('(max-width: 575px)');
if (mq_footer_max.matches) {
    $('.footer-full__heading').click(function () {
        $(this).find('.division-toggle button').toggleClass('tcon-transform');
        $(this).next().slideToggle('fast');
        $(this).toggleClass('expand');
    });
}
var mq_footer_min = window.matchMedia('(min-width: 575px)');
if (mq_footer_min.matches) {
    $('.footer-full__heading').click(function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return false;
    });
}
// Footer Mobile accordion - end



// WEBPACK FOOTER //
// ./scripts/routes/partials/footer-full.js